/* eslint-disable */
import ajax from '../utils/ajaxHelper';
import { useCallback } from 'react';

const useAnnouncements = () => {
  const addAnnouncement = useCallback(async (val) => {
    try {
      return await ajax.post(`announcements/add-announcements`, val);
    } catch (error) {
      return error;
    }
  });

  const updateSelectedAnnouncement = useCallback(async (val) => {
    try {
      return await ajax.post(`announcements/update-announcements`, val);
    } catch (error) {
      return error;
    }
  });

  const getMyAnnouncements = useCallback(async (val) => {
    try {
      const values = { userId: val };
      return await ajax.post(`announcements/get-my-announcements`, values);
    } catch (error) {
      return error;
    }
  });

  const getAnnouncements = useCallback(async (val) => {
    try {
      return await ajax.post(`announcements/get-all-announcements`, val);
    } catch (error) {
      return error;
    }
  });

  const deleteAnnouncement = useCallback(async (val, userId) => {
    try {
      const value = { announcementId: val };
      await ajax.post(`announcements/delete-announcement`, value);
    } catch (error) {
      return error;
    }
  });

  const getSingleAnnouncement = useCallback(async (val) => {
    try {
      const values = { announcementId: val };
      return await ajax.post(`announcements/get-single-announcement`, values);
    } catch (error) {
      return error;
    }
  });

  const getFilteredAllAnnouncements = useCallback(async (val) => {
    try {
      let result = await ajax.post(`announcements/get-filtered-announcements`, val);
      return result;
    } catch (error) {
      return error;
    }
  });

  const getFilteredMyAnnouncements = useCallback(async (val) => {
    try {
      let result = await ajax.post(`announcements/get-filtered-my-announcements`, val);
      return result;
    } catch (error) {
      return error;
    }
  });

  const updateAnnouncementCountForUser = useCallback(async (val) => {
    const values = { id: val };
    try {
      return await ajax.post(`announcements/update-announcement-count-for-user`, values);
    } catch (error) {
      return error;
    }
  });

  const getAllUserlist = useCallback(async (val) => {
    const value = { id: val };
    try {
      return await ajax.post(`announcements/get-all-userlist`, value);
    } catch (error) {
      return error;
    }
  });

  const getUnreadAnnouncementCount = useCallback(async (val) => {
    try {
      const values = { userId: val };
      return await ajax.post(`announcements/get-unread-announcement-count`, values);
    } catch (error) {
      return error;
    }
  });

  const _360PeerReview = useCallback(async (formId, users, sentBy, formName) => {
    try {
      const val = { formName: 'formName' };
      let result = await ajax.post(`forms/send360-employe-peers`, val);
      return result;
    } catch (error) {
      return error;
    }
  });

  return {
    addAnnouncement,
    updateSelectedAnnouncement,
    getAnnouncements,
    getMyAnnouncements,
    deleteAnnouncement,
    getSingleAnnouncement,
    getFilteredMyAnnouncements,
    getFilteredAllAnnouncements,
    updateAnnouncementCountForUser,
    getAllUserlist,
    getUnreadAnnouncementCount,
    _360PeerReview,
  };
};

export default useAnnouncements;
